import React, { useEffect, useState } from "react";

import { Plus, Trash2, Pencil, Save, GripVertical } from 'lucide-react';

import { TableContainer, TableRow, IconButton, TextField, Table, Fab, Select, InputLabel, FormControl, Paper } from '@mui/material';
import './TableStyle.css';
import { makeStyles } from "@material-ui/core/styles";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { externalApiTypes } from "../../../../Config/constants";

function TableList(props) {
    const classes = useStyles();
    var today = new Date();
    const [saveHelper, setSaveHelper] = useState(false);

    useEffect(() => {
        // eslint-disable-next-line
    }, [props.Login.userid]);

    const onDragEnd = (result) => {
        if (!result.destination) return;

        const reorderedRows = Array.from(props.rows);

        // Remove the dragged item from its original position
        const [movedRow] = reorderedRows.splice(result.source.index, 1);

        // Insert the dragged item into its new position
        reorderedRows.splice(result.destination.index, 0, movedRow);

        // Update the Ids to match the new positions
        const updatedRows = reorderedRows.map((row, index) => ({
            ...row,
            Id: index + 1, // Set Id to match the 1-based index
        }));

        props.setRows(updatedRows);
    };


    const GenerateId = () => {
        let tempArray = [...props.rows];
        const ids = tempArray.map((object) => object.Id);
        const max = Math.max(...ids);

        return tempArray.length === 0 ? 1 : max + 1;
    };

    const addRow = () => {
        const newRow = {
            Id: GenerateId(),
            itemDescription: '',
            edit: true,
            itemName: '',
            UserId: props.Login.userid,
            InsertedOn: today,
        };
        const tempArray = [...props.rows];
        tempArray.push(newRow);
        props.setRows(tempArray);
    };

    const setItemName = (event, id) => {
        let tempArray = [...props.rows];
        const targetRow = tempArray.find((x) => x.Id === id);
        if (targetRow) targetRow.itemName = event.target.value;
        props.setRows(tempArray);
    };

    const setItemDescription = (event, id) => {
        let tempArray = [...props.rows];
        const targetRow = tempArray.find((x) => x.Id === id);
        if (targetRow) targetRow.itemDescription = event.target.value;
        props.setRows(tempArray);
    };

    const editListItem = (id) => {
        let tempArray = [...props.rows];
        const targetRow = tempArray.find((x) => x.Id === id);
        if (targetRow) targetRow.edit = true;
        props.setRows(tempArray);
    };

    const saveListItem = (id) => {
        let tempArray = [...props.rows];
        const targetRow = tempArray.find((x) => x.Id === id);
        if (targetRow && targetRow.itemName) {
            targetRow.edit = false;
            props.setRows(tempArray);
            setSaveHelper(false);
        } else {
            setSaveHelper(true);
        }
    };

    const deleteListItem = (id) => {
        let tempArray = [...props.rows];
        const index = tempArray.findIndex((x) => x.Id === id);
        if (index > -1) tempArray.splice(index, 1);
        props.setRows(tempArray);
    };

    const isDefaultStopwatchKey = (itemName) => {
        return itemName === 'stopwatchReference' || itemName === 'startTime' || itemName === 'stopTime' || itemName === 'keyValue' || itemName === 'singleTimer';
    };

    const isDefaultDataKey = (itemName) => {
        return itemName === 'keyValue';
    };

    return (
        <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="tableRows">
                {(provided) => (
                    <TableContainer
                        {...provided.droppableProps}
                        ref={provided.innerRef}
                        style={{ borderTopRightRadius: '8px', borderTopLeftRadius: '8px' }}
                        component={Paper}
                    >
                        <Table>
                            <thead className={classes.tableHead}>
                                <tr>
                                    <th align="center">#</th>
                                    <th></th>
                                    <th width="30%">Name</th>
                                    <th width="60%">Description</th>
                                    <th width="10%" colSpan={2} align="center">Actions</th>
                                </tr>
                            </thead>
                            <tbody align="center" className={classes.tableContent}>
                                {props.rows.map((x, index) => (
                                    <Draggable key={x.Id} draggableId={x.Id.toString()} index={index}>
                                        {(provided) => (
                                            <TableRow
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                className={classes.tableRow}
                                            >
                                                <td className={classes.indexTd}>
                                                    <div className={classes.listOrder}>{x.Id}</div>
                                                </td>
                                                <td className={classes.dragTd}  {...provided.dragHandleProps}>
                                                    <GripVertical />
                                                </td>
                                                <td className={classes.tableTd}>
                                                    {x.edit ? (
                                                        <TextField
                                                            label={x.itemName ? ' ' : 'Name'}
                                                            InputLabelProps={{ shrink: false }}
                                                            style={saveHelper ? { border: 'solid 2px', borderColor: '#d32f2f', borderRadius: '7px', width: '100%', minWidth: '100px' } : { width: '100%', minWidth: '100px' }}
                                                            type="search"
                                                            variant="outlined"
                                                            value={x.itemName.length > 0 ? x.itemName : ''}
                                                            onChange={(event) => setItemName(event, x.Id)}
                                                        />
                                                    ) : (
                                                        <TextField style={{ width: '100%', minWidth: '100px' }} disabled value={x.itemName} />
                                                    )}
                                                </td>
                                                <td className={classes.tableTd}>
                                                    {x.edit ? (
                                                        <TextField
                                                            label={x.itemDescription ? ' ' : 'Description'}
                                                            InputLabelProps={{ shrink: false }}
                                                            style={{ width: '100%', minWidth: '140px' }}
                                                            className={classes.descriptionField}
                                                            id="outlined-basic"
                                                            type="search"
                                                            variant="outlined"
                                                            value={x.itemDescription.length > 0 ? x.itemDescription : ''}
                                                            onChange={(event) => setItemDescription(event, x.Id)}
                                                        />
                                                    ) : (
                                                        <TextField style={{ width: '100%', minWidth: '140px' }} disabled value={x.itemDescription !== '' ? x.itemDescription : x.description} />
                                                    )}
                                                </td>
                                                <td className={classes.tableTd} align="center">
                                                    {x.edit ? (
                                                        <IconButton aria-label="save" disabled={(props.apiTypeId === externalApiTypes.STOPWATCH && isDefaultStopwatchKey(x.itemName)) || props.apiTypeId === externalApiTypes.DATA && isDefaultDataKey(x.itemName)} onClick={() => saveListItem(x.Id)} className={classes.editButton} size="large">
                                                            {/* disabled class if nescessary */}
                                                            <Save
                                                                className={`${(props.apiTypeId === externalApiTypes.STOPWATCH && isDefaultStopwatchKey(x.itemName)) || props.apiTypeId === externalApiTypes.DATA && isDefaultDataKey(x.itemName) ? classes.disabledIcon : ''}`}
                                                                fontSize="inherit"
                                                            />
                                                        </IconButton>
                                                    ) : (
                                                        <IconButton aria-label="edit" disabled={(props.apiTypeId === externalApiTypes.STOPWATCH && isDefaultStopwatchKey(x.itemName)) || props.apiTypeId === externalApiTypes.DATA && isDefaultDataKey(x.itemName)} onClick={() => editListItem(x.Id)} className={classes.editButton} size="large">
                                                            <Pencil
                                                                className={`${(props.apiTypeId === externalApiTypes.STOPWATCH && isDefaultStopwatchKey(x.itemName)) || props.apiTypeId === externalApiTypes.DATA && isDefaultDataKey(x.itemName) ? classes.disabledIcon : ''}`}
                                                                fontSize="inherit"
                                                            />
                                                        </IconButton>
                                                    )}
                                                </td>
                                                <td className={classes.tableTd}>
                                                    <IconButton aria-label="delete" disabled={(props.apiTypeId === externalApiTypes.STOPWATCH && isDefaultStopwatchKey(x.itemName)) || props.apiTypeId === externalApiTypes.DATA && isDefaultDataKey(x.itemName)} onClick={() => deleteListItem(x.Id)} className={classes.functionButton} color="error" size="large">
                                                        <Trash2
                                                            className={`${(props.apiTypeId === externalApiTypes.STOPWATCH && isDefaultStopwatchKey(x.itemName)) || props.apiTypeId === externalApiTypes.DATA && isDefaultDataKey(x.itemName) ? classes.disabledIcon : ''}`}
                                                            fontSize="inherit"
                                                        />
                                                    </IconButton>
                                                </td>
                                            </TableRow>
                                        )}
                                    </Draggable>
                                ))}
                                {provided.placeholder}
                                <TableRow className={classes.addRow} onClick={addRow}>
                                    <td className={classes.indexTd}>-</td>
                                    <td className={classes.dragTd}></td>
                                    <td className={classes.tableTd} style={{ minWidth: '100px' }}>
                                        <FormControl fullWidth>
                                            <InputLabel>Name</InputLabel>
                                            <Select IconComponent={() => null} disabled />
                                        </FormControl>
                                    </td>
                                    <td className={classes.tableTd} style={{ minWidth: '140px' }}>
                                        <FormControl fullWidth>
                                            <InputLabel>Description</InputLabel>
                                            <Select IconComponent={() => null} disabled />
                                        </FormControl>
                                    </td>
                                    <td className={classes.tableTd} colSpan="2" align="center">
                                        <Fab size="medium">
                                            <Plus />
                                        </Fab>
                                    </td>
                                </TableRow>
                            </tbody>
                        </Table>
                    </TableContainer>
                )}
            </Droppable>
        </DragDropContext>
    );
}

export default TableList;

const useStyles = makeStyles({
    tableContent: {
        paddingTop: "15px",
    },
    tableRow: {
        height: '60px',
    },
    tableHead: {
        backgroundColor: "#e0dce4",
        marginBottom: "15px",
    },
    addRow: {
        opacity: "0.3"
    },
    tableTd: {
        padding: "5px",
    },
    descriptionField: {
        width: "100%",
    },
    editButton: {
        fontSize: '2rem !important',
        color: '#0B4097 !important',
    },
    functionButton: {
        fontSize: '2rem !important',
    },
    disabledIcon: {
        color: '#DCDCDC !important',
    },
    indexTd: {
        borderRight: '2px solid rgb(224, 224, 224)',
        width: '25px',
        background: 'rgba(0, 0, 0, 0.54)',
        color: 'white',
        zIndex: '2',
    },
    emptydrag: {
        padding: '17px !important',
        border: '0'
    },
    listOrder: {
        paddingLeft: '5px',
        paddingRight: '5px',
    },
    dragTd: {
        border: '0',
        width: '24px',
    },
    dragIcon: {
        float: 'left',
    },
});